<template>
  <v-dialog
    v-model="_screenActive"
    persistent
    :fullscreen="this.$vuetify.breakpoint.smAndDown"
    :width="dialogStyle"
  >
    <v-card style="overflow-x: hidden">
      <v-card>
        <v-card color="secondary" tile>
          <v-card-title class="py-0 white--text" color="primary">
            <v-container>
              <v-row>
                <v-col class="pb-0">
                  <v-card-text class="text-center font-weight-bold pb-0">
                    {{
                      this._client.client_name === 'shark'
                        ? `New Golf Car`
                        : `New Screen`
                    }}
                  </v-card-text>
                </v-col>
              </v-row>
            </v-container>
          </v-card-title>
        </v-card>
        <v-card class="d-flex align-center flex-column">
          <v-form
            class="pa-3"
            ref="form"
            v-model="isFormValid"
            style="width:70%;"
          >
            <v-text-field
              v-model="deviceId"
              label="Device Id"
              :rules="idRules"
              filled
              required
            ></v-text-field>
            <v-text-field
              v-model="number"
              label="Phone Number"
              :rules="phoneRules"
              filled
              required
            ></v-text-field>
            <v-select
              v-model="group"
              :label="groupLabel"
              filled
              :rules="groupRules"
              item-text="text"
              :items="_filterOptions.groups.items"
              item-value="value"
              required
            ></v-select>
          </v-form>
          <div class="d-flex justify-center pb-5" style="width:100%;">
            <v-btn
              large
              color="primary"
              :disabled="!isFormValid"
              :class="textStyle"
              style="width: 30%;"
              @click="createScreen()"
              >Create Screen</v-btn
            >
          </div>
          <div class="d-flex justify-center pb-5" style="width:100%">
            <v-btn large style="width: 30%;" @click="closeModal()"
              >Cancel</v-btn
            >
          </div>
        </v-card>
      </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import { MobileView } from '@/mixins';

export default {
  data: () => ({
    deviceId: '',
    group: '',
    number: '',
    isFormValid: false,
    idRules: [
      v => v.toString().length > 2 || 'Device Id needs to exceed 2 characters.',
    ],
    groupRules: [v => v.toString().length > 0 || 'Please select a Group.'],
    phoneRules: [
      v => /^\d+$/.test(v) || 'Phone number must have digits only.',
      v => v.toString().length <= 10 || 'Phone number may not exceed 10 digits',
      v => v.toString().length > 9 || 'Phone number is not long enough.',
    ],
  }),
  mixins: [MobileView],
  methods: {
    ...mapMutations({
      _setActive: 'screens/setNewScreen',
    }),
    ...mapActions({
      _uploadDetails: 'screenDetails/uploadDetails',
      addScreen: 'screens/addScreen',
    }),
    createScreen() {
      const newScreen = {
        uuid: '',
        ad_schedule: '',
        beep: false,
        charged_off: false,
        group_id: this.group.toString(),
        debug: false,
        device_id: this.deviceId.toString(),
        notify_users: false,
        phone: this.number.toString(),
        screen_uptime: 0,
        session_status: 'Checked In',
        status: '',
        version: '1.2.3',
        trip_type: '',
        session_type: '',
        checked: false,
        pushy_token: '',
        last_activity: Math.round(new moment().format('X')),
      };
      if (this._client.client_name === 'bazzbi') {
        newScreen.trip_type = 'DIGITAL_KEY';
      } else if (this._client.client_name === 'shark') {
        newScreen.trip_type = 'PREMIUM';
      } else {
        newScreen.trip_type = 'ROUND_TRIP';
      }
      this.addScreen(newScreen);
      this.closeModal();
    },
    closeModal() {
      this.deviceId = '';
      this.group = '';
      this.phone = '';
      this.isFormValid = false;
      this._setActive(false);
    },
  },
  computed: {
    ...mapGetters({
      _screenActive: 'screens/getNewScreen',
      _userGroups: 'account/getUserGroups',
      _defaultNewScreen: 'screens/getDefaultNewScreen',
      _filterOptions: 'screens/getScreenFilterOptions',
      _client: 'account/getCurrentClient',
    }),
    dialogStyle() {
      if (this.showMobileView) {
        return '';
      }
      return '70%';
    },
    groupLabel() {
      if (this._client.client_name != 'shark') {
        return 'Group Name';
      }
      return 'Course Name';
    },
  },
  watch: {
    _screenActive() {
      this.$refs.form.reset();
    },
  },
};
</script>

<style></style>
